import React, { useState } from "react";

const VCardQrCode = ({ setQrData }) => {
    const [vcardData, setVcardData] = useState({
        name: "",
        organization: "",
        title: "",
        email: "",
        phone: "",
        address: "",
        url: "",
        birthday: ""
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setVcardData(prevData => {
            const newData = { ...prevData, [name]: value };
            setQrData(`BEGIN:VCARD\nVERSION:3.0\nFN:${newData.name}\nORG:${newData.organization}\nTITLE:${newData.title}\nEMAIL:${newData.email}\nTEL:${newData.phone}\nADR:${newData.address}\nURL:${newData.url}\nBDAY:${newData.birthday}\nEND:VCARD`);
            return newData;
        });
    };

    return (
        <>
            <div className="form-group">
                <label htmlFor="vcard-name">Nome</label>
                <input type="text" id="vcard-name" name="name" placeholder="Maria Silva" value={vcardData.name} onChange={handleInputChange} />
            </div>
            <div className="form-group">
                <label htmlFor="vcard-organization">Organização</label>
                <input type="text" id="vcard-organization" name="organization" placeholder="Empresa XYZ" value={vcardData.organization} onChange={handleInputChange} />
            </div>
            <div className="form-group">
                <label htmlFor="vcard-title">Título</label>
                <input type="text" id="vcard-title" name="title" placeholder="Gerente de Vendas" value={vcardData.title} onChange={handleInputChange} />
            </div>
            <div className="form-group">
                <label htmlFor="vcard-email">E-mail</label>
                <input type="email" id="vcard-email" name="email" placeholder="maria.silva@exemplo.com" value={vcardData.email} onChange={handleInputChange} />
            </div>
            <div className="form-group">
                <label htmlFor="vcard-phone">Telefone</label>
                <input type="tel" id="vcard-phone" name="phone" placeholder="+55 11 91234-5678" value={vcardData.phone} onChange={handleInputChange} />
            </div>
            <div className="form-group">
                <label htmlFor="vcard-address">Endereço</label>
                <input type="text" id="vcard-address" name="address" placeholder="Rua Exemplo, 123" value={vcardData.address} onChange={handleInputChange} />
            </div>
            <div className="form-group">
                <label htmlFor="vcard-url">URL</label>
                <input type="url" id="vcard-url" name="url" placeholder="https://exemplo.com" value={vcardData.url} onChange={handleInputChange} />
            </div>
            <div className="form-group">
                <label htmlFor="vcard-birthday">Aniversário</label>
                <input type="date" id="vcard-birthday" name="birthday" value={vcardData.birthday} onChange={handleInputChange} />
            </div>
        </>
    );
};

export default VCardQrCode;